import { withStyles } from '@material-ui/core';

import { Container } from 'shared/components/container/Container';

export const StyledContainer = withStyles(({ breakpoints }) => ({
  root: {
    paddingTop: 72,

    [breakpoints.down('sm')]: {
      paddingTop: 36,
    },
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(Container);
